export default __webpack_public_path__ + "static/media/turkey.ec1614df.svg";